module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('back-link'), _c('h1', {
    staticClass: "pull-left"
  }, [_vm._v("Notificações")]), _c('div', {
    staticClass: "clear"
  }), _c('div', {
    staticClass: "table notifications"
  }, [_c('div', {
    staticClass: "table-header table-row"
  }, [_c('div', {
    staticClass: "table-col notification-header"
  }, [_vm._v("Notificação")]), (!_vm.current_user.isSeller()) ? _c('div', {
    staticClass: "table-col notification-responsible"
  }, [_vm._v("Responsável")]) : _vm._e()]), _c('div', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.loadNotifications),
      expression: "loadNotifications"
    }],
    staticClass: "table-body"
  }, _vm._l((_vm.notifications), function(notif, index) {
    return _c('div', {
      staticClass: "table-row"
    }, [_c('div', {
      staticClass: "table-col notification"
    }, [_c('list-item', {
      attrs: {
        "notification": notif,
        "table": true
      }
    })], 1), (!_vm.current_user.isSeller()) ? _c('div', {
      staticClass: "table-col notification-responsible",
      class: notif.cssClasses()
    }, [_c('user-miniature', {
      attrs: {
        "user": notif.user,
        "options": {
          first_name: true
        }
      }
    })], 1) : _vm._e()])
  }), 0)]), _c('div', {
    attrs: {
      "align": "center"
    }
  }, [_c('loading', {
    attrs: {
      "loading": _vm.loading
    }
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.next_page),
      expression: "!next_page"
    }],
    staticClass: "light-gray-text light-text"
  }, [_vm._v("Sem mais resultados")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-522b3b66!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/shared/notifications/index.vue
// module id = 1120
// module chunks = 1